var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.uploadComponent,_vm._b({ref:"manager",tag:"component",attrs:{"errors":_vm.combinedErrors,"disabled":_vm.disabled,"readonly":_vm.readonly,"value":_vm.local,"item":_vm.item},on:{"input":_vm.updateLocal}},'component',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }